type MetadataTrack = { sourceType: string };

/** App-index overrides only; this does not write tags to audio files or platforms. */
export function trackMetadataEditCapability(track?: MetadataTrack | null): { editable: boolean; reason: string } {
  if (!track) return { editable: false, reason: '没有找到要编辑的歌曲' };
  if (track.sourceType === 'local') return { editable: true, reason: '' };
  return { editable: false, reason: track.sourceType === 'webdav' ? '仅支持本地音乐，WebDAV 暂不支持编辑覆盖信息' : '仅支持本地音乐' };
}
